<template>
  <div class="configurator-step-dealer-email">
    <div class="dealer-email-description">
      <h2 class="dealer-email-description__title">
        <i class="fa fa-check-circle" aria-hidden="true"></i> Ihr Fahrzeug ist bereit für die Preisbewertung!
      </h2>
      <p class="dealer-email-description__text">
        <strong>Letzter Schritt</strong>: Tragen Sie unten Ihre Daten ein, um eine kostenlose
        Preisbewertung zu erhalten. Sie bekommen ein unverbindliches Angebot zum Ankauf Ihres Fahrzeugs per E-Mail.
      </p>
    </div>
    <div class="dealer-email-car-details">
      <h4 class="dealer-email-car-details__maker">
        {{ selected("make") }} {{ selected("model") }}
      </h4>
      <div class="dealer-email-car-details__list">
        {{ selected("year") }},
        {{ selected("bodytype") }},
        {{ selected("fuel") }},
        {{ selected("power") }},
        {{ selected("engine") }},
        {{ selected("equipment") }},
        {{ entered("mileage") }} km,
        {{ checked("extras") }},
      </div>
      <i class="fa fa-pencil-square-o" aria-hidden="true" @click="edit"></i>
    </div>
    <div class="dealer-email-user-details">
      <h5 class="dealer-email-user-details__title">Ihre Daten</h5>
      <input type="text" placeholder="Vor- und Nachname" v-model="username">
      <input type="tel" placeholder="Telefon" v-bind:class="{ 'with-error': phoneError }" v-model="phone">
      <span class="dealer-email-user-details__error" v-if="phoneError">
        Bitte Telefon angeben
      </span>
      <input type="email" tabindex="-1" placeholder="E-Mail" v-bind:class="{ 'with-error': emailError }" v-model="email">
      <span class="dealer-email-user-details__error" v-if="emailError">
        Bitte E-Mail angeben
      </span>
    </div>
    <div class="dealer-email-user-confirm">
      <h5 class="dealer-email-user-confirm__title">Möchten Sie uns noch etwas mitteilen?</h5>
      <textarea
        v-model="message"
        placeholder="Ihre Nachricht"
        class="dealer-email-user-confirm__textarea">
      </textarea>
      <label class="dealer-email-user-confirm__disclaimer">
        <input class="checkbox" type="checkbox" v-model="policy" :checked="policy"/>
        <p class="disclaimer-text">
          Mit der Übermittlung Ihrer E-Mail-Adresse stimmen Sie den PKW.de
          <a href="https://www.pkw.de/datenschutz/" target="blank" tabindex="-1">Datenschutzbestimmungen</a>
          zu. Sie können Ihre Zustimmung jederzeit mit Wirkung für die Zukunft widerrufen.
        </p>
      </label>
      <button type="submit" class="dealer-email-user-confirm__submit-btn" v-on:click.prevent="submit" v-bind:disabled="!policy">
        <img src="~@widget/assets/widget-highline-icon-white.png" alt="tiny car image">
        Kostenlose Preisbewertung erhalten
      </button>
    </div>
  </div>
</template>

<script>
    import { Flow } from '../services/flow';

    export default {
        name: 'ConfiguratorStepDealerEmail',
        props: ['name', 'options'],
        data: function () {
            return {
              message: '',
              email: null,
              phone: null,
              username: null,
              policy: false,
              emailError: false,
              phoneError: false
            }
        },
        methods: {
            submit: function(event) {
                const payload = {
                  email: this.email,
                  phone: this.phone,
                  message: this.message,
                  username: this.username,
                };

                if (!this.isEmailValid(payload.email)) {
                  this.emailError = true;
                }

                if (!this.isPhoneValid(payload.phone)) {
                  this.phoneError = true;
                }

                if (!this.phoneError && !this.emailError) {
                  this.$store.dispatch('selectOption', { name: this.name, value: payload });
                  this.$store.dispatch('createWidgetLead');
                }
            },
            selected: function (param) {
                if (this.$store.state.selected[param]) {
                    let id = this.$store.state.selected[param];
                    let item = this.$store.state.options[param].find(function (element) {
                        return element.id == id;
                    });
                    return item.name;
                } else {
                    return 'keine';
                }
            },
            entered: function (param) {
                return this.$store.state.selected[param];
            },
            checked: function (param) {
                if (this.$store.state.selected[param]) {
                    let ids = this.$store.state.selected[param];
                    let items = this.$store.state.options[param].filter(function (element) {
                        return ids.indexOf(element.id) >= 0;
                    });
                    return items.map(x => x.name).join(", ");
                } else {
                    return 'keine';
                }
            },
            edit: function(event) {
                event.preventDefault();
                this.$store.commit("updateStep", Flow.firstStep());
            },
            isEmailValid: function(value) {
                return value !== null && value.length !== 0 && value.match(/.+@.+/) !== null;
            },
            isPhoneValid: function(value) {
              return value !== null && value.length !== 0;
            },
        },
        watch: {
          email: function() {
            this.emailError = false;
          },
          phone: function() {
            this.phoneError = false;
          }
        }
    }
</script>

<style lang="scss" scoped>
  @import "~@/assets/vars";
  @import '~@widget/assets/colors';

  * {
    scrollbar-width: thin;
    scrollbar-color: #c1c1c1 transparent;
  }
  *:hover {
    scrollbar-width: thin;
    scrollbar-color: #999999 transparent;
  }
  *::-webkit-scrollbar {
    width: 8px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 20px;
  }
  *::-webkit-scrollbar-thumb:hover {
    background-color: #999999;
  }

  .configurator-step-dealer-email {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 15px 20px;
    text-align: left;
    color: $widget-grey-dark-variant;

    & > div {
      width: calc(50% - 20px);
    }

    @include breakpoint(fromsmallmedium) {
      flex-direction: column;
      align-items: center;

      & > div {
        width: 100%;
      }

      .dealer-email-user-confirm {
        margin-top: 20px;
      }

      .dealer-email-user-confirm__disclaimer {
        padding: 15px 0;
      }
    }
  }

  .dealer-email-description__title {
    color: $widget-green;
    font-size: 20px;
    font-weight: bold;
    padding: 20px 0 16px;

    .fa-check-circle {
      display: inline-block;
      width: 20px;
      height: 20px;
      top: 3px;
    }
  }

  .dealer-email-description__text {
    font-size: 16px;
    padding-bottom: 20px;
    color: $widget-dark;
  }

  .dealer-email-user-details input {
    width: 100%;
    height: 53px;
    padding: 0 17px;
    border: 1px solid $widget-grey-variant;
    font-size: 16px;

    &.with-error {
      color: $widget-red-variant;
      border-color: $widget-red-variant;
      border-left-width: 3px;
      &::placeholder { color: $widget-red-variant; }
    }

    &::placeholder { color: $widget-grey-dark-variant; }
    &:not(:last-child) { margin-bottom: 20px; }
  }

  .dealer-email-user-details__error {
    position: relative;
    top: -15px;
    font-size: 16px;
    color: $widget-red-variant;
  }

  .dealer-email-user-confirm__title,
  .dealer-email-user-details__title {
    font-size: 16px;
    line-height: 16px;
    padding-bottom: 10px;
  }

  .dealer-email-car-details {
    position: relative;
    padding: 20px;
    margin-bottom: 20px;
    background-color: $widget-gray-light;

    .fa-pencil-square-o {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 20px;
      height: 18px;
      font-size: 18px;
      cursor: pointer;
    }
  }

  .dealer-email-car-details__maker {
    font-size: 20px;
    padding: 0 20px 16px 0;
    color: $widget-grey-dark-variant;
  }

  .dealer-email-car-details__list {
    font-size: 16px;
  }

  .dealer-email-user-confirm__textarea {
    resize: none;
    width: 100%;
    height: 90px;
    padding: 17px;
    font-size: 16px;
    color: $widget-grey-dark-variant;
    border: 1px solid $widget-grey-variant;
    &::placeholder {
      font-family: 'Asap', sans-serif;
      color: $widget-grey-dark-variant;
    }
  }

  .dealer-email-user-confirm__disclaimer {
    display: flex;
    cursor: pointer;
    align-items: center;
    user-select: none;
    margin-top: -2px;
    margin-bottom: 6px;

    .checkbox {
      display: block;
      min-width: 20px;
      min-height: 20px;
      margin: 0 16px 0 0;
      border: 1px solid $widget-grey-variant;
      cursor: pointer;

      &:checked {
        color: $widget-grey-dark-variant;
      }

      &:checked::after {
        content: "";
        display: block;
        top: 2px;
        left: 2px;
        width: 14px;
        height: 14px;
        background-image: url("~@widget/assets/check.svg");
      }
    }

    .disclaimer-text {
      font-size: 12px;
      line-height: 15px;
      color: $widget-light;

      a {
        color: #C0131B;
      }
    }
  }

  .dealer-email-user-confirm__submit-btn {
    width: 100%;
    height: 53px;
    line-height: 53px;
    color: white;
    font-size: 16px;
    font-weight: bold;
    background-color: $widget-grey-dark-variant;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:disabled {
      cursor: not-allowed;
      background-color: #a1a1a1;
    }

    img {
      display: none;
      padding-right: 14px;
      vertical-align: middle;

      @media (min-width: 480px) {
        display: inline-block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorStepDealerEmail.vue